import { toast } from "react-hot-toast";

export const handleError = err => {
  const errorMessage = err?.response?.data?.message || 'An unknown error occurred. Please try again.';
  
  toast.error(errorMessage);
}
